import React from "react";

export default function ListItemCell({
  outline = false,
  icon,
  children,
  className,
  ...rest
}) {
  return <div className={className}>{children}</div>
};
